<!-- =========================================================================================
    File Name: Dropfiles.vue
    Description: Page to drop files & upload bills
========================================================================================== -->
<template>
  <div class="dropfiles">
    <column-layout>
      <div class="flex flex-wrap justify-between items-start mb-8">
        <h2 class="font-light text-lg my-3">GLISSEZ / DÉPOSEZ VOS DOCUMENTS :</h2>
      </div>

      <upload-files @uploadDone="listUploadedFiles()"></upload-files>

      <vs-card class="px-4 text-left" v-if="files && files.length > 0">

        <vs-table search stripe max-items="10" pagination :data="files">
          <template slot="header">
            <h3 class="h5 uppercase">
              Vos documents en cours de transfert
            </h3>
          </template>
          <template slot="thead">
            <vs-th style="width:20px">&nbsp;</vs-th>
            <vs-th sort-key="name">Nom du fichier</vs-th>
            <vs-th sort-key="dateUpload">date d'envoi</vs-th>
            <vs-th sort-key="extention">type</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(file, index) in data">
              <vs-td>
                <feather-icon icon="FileIcon" svgClasses="h-6 w-6 stroke-current text-success" />
              </vs-td>

              <vs-td :data="data[index].name">
                {{ data[index].name }}
              </vs-td>

              <vs-td :data="data[index].dateUpload">
                Le {{ data[index].dateUpload | moment('DD-MM-YYYY à HH:MM') }}
              </vs-td>

              <vs-td :data="data[index].extention">
                {{ data[index].extension }}
              </vs-td>

              <vs-td :data="data[index].id" style="width: 180px">
                <div class="flex justify-end">
                  <vs-button icon-pack="feather" icon="icon-trash" type="border" color="danger" @click="deleteFile(data[index].id)" target="blank">Effacer</vs-button>
                </div>
              </vs-td>

            </vs-tr>
          </template>

        </vs-table>
      </vs-card>

      <!--  ASIDE -->
      <template slot="aside">

        <h2 class="font-light text-lg mt-20 mb-4">AIDE À L'IMPORTATION :</h2>
        <div class="text-sm md:pr-4">
          <p class="mb-4">Vous pouvez déposer vos factures en les faisant simplement glisser sur la zone au centre de la page. Les fichiers peuvent être au format PDF (format conseillé).</p>
          <p class="mb-4">Les fichiers PDF peuvent contenir un ou plusieurs factures, concernant plusieurs clients différents. Tous les autres formats ne peuvent contenir qu’une seule facture par fichier.</p>
          <p class="mb-4">Lorsque les fichiers sont déposés, ils apparaissent en dessous dans la zone d’attente de traitement. Vous pouvez les supprimer à ce moment là, ils ne seront plus importés ni traités.</p>
          <p class="mb-8">N’hésitez pas à nous contacter si vous rencontrez des difficultés de transfert.</p>
          <p class="mb-4">Type de fichiers acceptés :</p>
          <p class="mb-8"><strong>.PDF</strong></p>
          <p class="mb-4">Taille de fichier :</p>
          <p class="mb-8"><strong>20 Mo maximum par fichier</strong></p>
        </div>
      </template>

    </column-layout>
  </div>
</template>

<script>
// @ is an alias to /src
import ColumnLayout from '@/layouts/columns/ColumnLayout.vue'
import UploadFiles from '@/components/upload-files/UploadFiles'

import UploadFilesService from '@/services/UploadFilesService'

// import ImportExcel from '@/components/excel/ImportExcel.vue'

export default {
  name: 'Dropfiles',
  components: {
    ColumnLayout,
    UploadFiles
  },
  data () {
    return {
      files: [],
      intervalId: null
    }
  },
  mounted () {
    this.listUploadedFiles()
    // console.log('set inteval')
    this.intervalId = setInterval(() => {
      this.listUploadedFiles()
    }, 30000) //refresh page every 30 seconds
  },
  destroyed () {
    // console.log('inteval destroyed')
    clearInterval(this.intervalId)
  },
  methods: {
    listUploadedFiles () {
      this.$vs.loading()
      UploadFilesService.getFiles().then((res) => {
        this.files = res.data
      }).then(() => {
        this.$vs.loading.close()
      }).catch(() => {
        this.$vs.loading.close()
      })
    },
    forceFileDownload (response, title) {
      // console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    deleteFile (id) {
      UploadFilesService
        .deleteFile(id).then(() => {
          this.$vs.notify({
            title: 'Fichier effacé',
            text: 'Votre fichier a bien été retiré de la liste des transferts',
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
          this.listUploadedFiles()
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Lecture du fichier',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>

<style language="scss">


</style>
